export default "__VITE_ASSET__zYwRuEvI__"